import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import CustomerList from "@/components/lists/customer.vue"
  import CustomerToolbar from "@/components/toolbars/customer.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Customer,
    CustomerEnumerationResponse,
    CustomerInput,
    CustomerResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Customer as CustomerClient} from "@/endpoints/rutsolve/gql/resolvers/customer"
  import {Enumeration as EnumerationClient} from "@/endpoints/rutsolve/gql/resolvers/enumeration"
  import {CustomerSelector as Storage} from "@/storage/customer_selector"
  import ErrorModal from "@/components/modals/error.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'customer',
  props: {
    "value": {
    default: null,
    required: false,
    type: Object as PropType<Customer>
  },
    "valueModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels([
    "select",
  ], ["update:value"]),
  setup(__props, { emit: __emit }) {

  const value = _useModel(__props, "value")

  const emits = __emit

  const error = ref<Error>(null)
  const customerClient = new CustomerClient()
  const enumerationClient = new EnumerationClient()
  const customerResponse = ref<CustomerResponse>(null)
  const customerEnumerationResponse = ref<CustomerEnumerationResponse>(null)
  const customerInput = ref<CustomerInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeCustomerInput(customerInput.value)
    read()
  }

  async function select() {
    const selectedCustomer = customerResponse.value.records[selectedIndex.value]
    value.value = selectedCustomer
    Storage.writeSelectedCustomerID(selectedCustomer.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteCustomerInput()
    Storage.deleteSelectedCustomerID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      customerEnumerationResponse.value = await enumerationClient.readCustomerEnumerations()
      const storedCustomerInput = Storage.readCustomerInput()
      customerInput.value = structuredClone(storedCustomerInput)
      customerResponse.value = await customerClient.selector(storedCustomerInput)
      if (!customerResponse.value || !customerResponse.value.records) {
        return
      }
      const storedSelectedCustomerID = Storage.readSelectedCustomerID()
      for (const [index, customer] of customerResponse.value.records.entries()) {
        if (customer.id == storedSelectedCustomerID) {
          selectedIndex.value = index
          value.value = customer
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      (customerEnumerationResponse.value)
        ? (_openBlock(), _createBlock(CustomerToolbar, {
            key: 0,
            value: customerInput.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((customerInput).value = $event)),
            customerOrders: customerEnumerationResponse.value.orders,
            customerTypes: customerEnumerationResponse.value.types,
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (update())),
            onReset: _cache[2] || (_cache[2] = ($event: any) => (reset()))
          }, null, 8, ["value", "customerOrders", "customerTypes"]))
        : _createCommentVNode("", true),
      (customerResponse.value)
        ? (_openBlock(), _createBlock(CustomerList, {
            key: 1,
            selectedIndex: selectedIndex.value,
            "onUpdate:selectedIndex": _cache[3] || (_cache[3] = ($event: any) => ((selectedIndex).value = $event)),
            items: customerResponse.value.records,
            onSelect: _cache[4] || (_cache[4] = ($event: any) => (select()))
          }, null, 8, ["selectedIndex", "items"]))
        : _createCommentVNode("", true),
      (customerResponse.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 2,
            currentPage: customerInput.value.plot.page,
            "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((customerInput.value.plot.page) = $event)),
            itemTotal: customerResponse.value.recordsTotal,
            pageItems: customerInput.value.plot.items,
            onUpdate: _cache[6] || (_cache[6] = ($event: any) => (update()))
          }, null, 8, ["currentPage", "itemTotal", "pageItems"]))
        : _createCommentVNode("", true),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 3,
            error: error.value,
            "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})